import React from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Button } from '@mui/material';

import Img from 'retired/Img';
import LogoLoader from 'assets/deed-logo-horizontal.svg';

import { useStyles } from './style';

export interface ErrorBoundaryPageProps {
  resetError: () => void;
}

export const ErrorBoundaryPage = ({ resetError }: ErrorBoundaryPageProps): JSX.Element => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.mainContainer}>
      <div className={classes.innerContainer}>
        <Button
          variant="text"
          onClick={() => {
            resetError();
            history.push('/');
          }}
          style={{ marginBottom: '8px' }}
        >
          <Img src={LogoLoader} alt="Click to go back to the homepage" />
        </Button>
        <Typography variant="h5">Oops, something went wrong!</Typography>
        <Typography variant="h5">Please go back to the homepage</Typography>
      </div>
    </div>
  );
};
